import { computed } from 'vue'
import { useCoinPriceAPIStore, useCoinStore } from '@/stores'
import { type Maybe, BaseCoin, type BaseCoinPrice, Coin } from '@/types'

// V1/V2 호환 Token 정보 인터페이스
interface ITokenInfoInput {
  id: number
  coinId?: number
  name?: string
  symbol: string
  iconUrl?: string
  decimals: number
  contract?: string
  contractAddress?: string
  cmkId?: number
  coinGeckoId?: string
  cgkId?: string
  property?: Record<string, unknown>
  _parentCurrency?: any
}

export class Token extends BaseCoin {
  id: number
  name?: string | undefined
  contract: string
  symbol: string
  iconUrl?: string | undefined
  decimals: number
  cmkId?: number | undefined
  coinGeckoId?: string | undefined
  coinId: number
  coin: Maybe<Coin>
  priceInfo: Maybe<BaseCoinPrice>
  property?: Record<string, unknown>

  constructor(tokenInfo: ITokenInfoInput) {
    super()
    this.id = tokenInfo.id
    this.coinId = tokenInfo.coinId ?? 0
    this.name = tokenInfo.name
    this.symbol = tokenInfo.symbol
    this.iconUrl = tokenInfo.iconUrl
    this.decimals = tokenInfo.decimals
    this.contract = tokenInfo.contract || tokenInfo.contractAddress || ''
    this.cmkId = tokenInfo.cmkId
    this.coinGeckoId = tokenInfo.coinGeckoId || tokenInfo.cgkId
    this.property = tokenInfo.property

    const coinStore = useCoinStore()
    const computedCoin = computed(() => {
      // V2: coinId가 string이면 parentCurrency 정보 직접 사용
      if (
        typeof this.coinId === 'string' &&
        (tokenInfo as any)._parentCurrency
      ) {
        return (tokenInfo as any)._parentCurrency
      }
      // V1: numeric coinId로 검색
      return coinStore.coinList?.find((coin) => coin.id === this.coinId)
    })
    Object.defineProperty(this, 'coin', {
      get(): Maybe<Coin> {
        return computedCoin.value
      },
    })
    const coinPriceAPIStore = useCoinPriceAPIStore()
    const computedPriceInfo = computed(() => {
      if (!this.coinGeckoId) return
      return coinPriceAPIStore.getCoinPrice(this.coinGeckoId)
    })
    Object.defineProperty(this, 'priceInfo', {
      get(): Maybe<BaseCoinPrice> {
        return computedPriceInfo.value
      },
    })
  }

  get supportNft() {
    if (!this.coin) return
    return this.coin.supportNft
  }

  get explorerUrl() {
    if (!this.coin) return
    return this.coin.explorerUrl
  }
  get color() {
    if (!this.coin) return '#000000'
    return this.coin.color
  }
  get networkSymbol() {
    return this.coin?.symbol
  }
  get networkIcon() {
    return this.coin?.iconUrl
  }
  get networkName() {
    return this.coin?.name
  }
  get feeType() {
    return this.coin?.feeType
  }
  get coreNetwork() {
    return this.coin?.coreNetwork
  }
  get networkDecimals() {
    return this.coin?.networkDecimals
  }
  get explorerAddress() {
    return this.coin?.explorerAddress
  }
  get explorerTransaction() {
    return this.coin?.explorerTransaction
  }
  get explorerContract() {
    return this.coin?.explorerContract
  }
  get networkPriceInfo() {
    return this.coin?.priceInfo
  }
}
